import { differenceInMinutes } from 'date-fns';

const consentTimeInMinutes = 10;

export const consentNotShownInLastTenMins = (
    consentCookieValue: string | undefined
): boolean => {
    if (!consentCookieValue) {
        return false;
    }
    const existingDate = new Date();
    try {
        const parsedCookie = JSON.parse(consentCookieValue);
        if (parsedCookie?.content?.consents[0]?.date) {
            const bannerDate = new Date(
                parsedCookie?.content?.consents[0]?.date
            );
            return (
                differenceInMinutes(existingDate, bannerDate) >
                consentTimeInMinutes
            );
        }
        return false;
    } catch (e) {
        return false;
    }
};
